require('../../../assets/lib/jqPlot-1.0.9/excanvas.js');
require('../../../assets/lib/jqPlot-1.0.9/jquery.jqplot.js');
require('../../../assets/lib/jqPlot-1.0.9/jqplot.pieRenderer.js');
require('../../../assets/lib/fileuploader/fileuploader.js');
require('../../../assets/lib/select2/select2-3.4.5/select2.min.js');
require('../../../assets/lib/js/angularmodule/JV.Core.Directives.js');
require('../../../assets/lib/zclip/ZeroClipboard.js');
require('../../../assets/lib/js/jv.ModalWidget.webpack.js');
require('../../../assets/scripts/common/jv.i18n.js');
require('../../../assets/scripts/jhire/services/jv.Pending.Approvals.Service.js');
require('../../../assets/scripts/common/directives/jv.Datepicker.js');
require('../../../assets/scripts/candidates/details/jv.friendWidgetMin.webpack.js');
require('../../../assets/scripts/candidates/jv.candidate.modal.controller.js');
require('../../../assets/scripts/candidates/jv.rejectCandidate.controller.js');
require('../../../assets/scripts/candidates/jv.changeStatus.controller.js');
require('../../../assets/scripts/common/jv.Modal.js');
require('../../../assets/scripts/common/jv.TemplateLoader.js');
require('../../../assets/scripts/jhire/services/jv.Reqs.js');
require('../../../assets/scripts/jhire/services/jv.AutomationModal.js');
require('../../../assets/scripts/jhire/services/jv.apply-form-preview.service.js');
require('../../../assets/scripts/jhire/modules/jv.Reqs.Details.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsTabsCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsDetailsCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsLiRecommendations.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsSummaryCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsFormCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsNotesCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsCandidatesCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsActivitiesCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.Requisition.Analytics.Controller.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsLinkedInCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqseQuestCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsJobTargetCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsJobLinkCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsRetractCtrl.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ApprovalDir.js');
require('../../../assets/scripts/admin/directives/jv.Admin.CustomFormField.directive.js');
require('../../../assets/scripts/jhire/controllers/requisitions/jv.ReqsLiJobPostingStautsCtrl.js');
require('../../../assets/scripts/common/jv.NumberFormat.mask.directive.js');
require('../../../assets/scripts/source/person/JV.Applicant.js');
require('../../../assets/scripts/source/person/JV.AngularUtils.js');
require('../../../assets/scripts/source/person/JV.QuickViewCtrl.js');
require('../../../assets/scripts/source/contacts/jv.applicantGrid.controller.js');
require('../../../assets/scripts/videos/recruiter/jv.Cand.List.QuickViewVideo.js');
require('../../../assets/scripts/videos/recruiter/jv.Videos.Svc.js');
require('../../../assets/scripts/common/jv.Jobvite.Urls.js');
require('../../../assets/scripts/common/jv.BrowserDetails.js');
require('../../../assets/scripts/common/angajaxservice.js');
require('../../../assets/scripts/common/directives/jv.fallbackImage.js');
require('../../../assets/scripts/candidates/jv.candidates.service.js');
require('../../../assets/scripts/common/directives/jv.AjaxSelect.js');
require('../../../assets/scripts/common/directives/jv.Common.Currency.Directive.js');
require('../../../assets/scripts/common/directives/jv.common.currency.applyfield.directive.js');
require('../../../assets/scripts/common/directives/jv.MessageTemplate.js');